import { useState } from 'react';
import { getMuted, setMuted } from '../hooks/useSound';

export function MuteToggle() {
  const [muted, setMutedState] = useState(getMuted);

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
  };

  return (
    <button
      onClick={toggle}
      className="fab fab--small fab--mute"
      aria-label={muted ? 'Unmute sounds' : 'Mute sounds'}
    >
      {muted ? '\uD83D\uDD07' : '\uD83D\uDD0A'}
    </button>
  );
}
